import React, { useEffect, useState } from "react";


import { JWT } from "../../../constants/local-storage";

import AmChartRingIndicator from "../../../components/AmChartRingIndicator";


export default function RoomBookingsDrawer(props) {

    const [dashboard, setDashboard] = useState(null);
	
	
	

    var filter = props.filter;

    var summary = dashboard && dashboard.summary
        ? dashboard.summary
        : null;

    // --------------------------------------------------------
    // LOAD DATA
    // --------------------------------------------------------

    useEffect(function () {

        loadDashboard();

    }, [filter]);

    function loadDashboard() {

        const token = localStorage.getItem(JWT);

        fetch("/resolutionsoftwareplatform/roombookingdashboard/get", {

            method: "POST",

            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            },

            body: JSON.stringify(filter)

        })
        .then(function (response) {

            return response.json();

        })
        .then(function (data) {

            setDashboard(data);

            console.log(data);

        })
        .catch(function (error) {

            console.error("Error loading drawer dashboard:", error);

        });
    }
	
	
	// --------------------------------------------------------
	   // LOAD DETAILS DRAWER
	   // --------------------------------------------------------

	   function openDetailsDrawer() {

	       const token =
	           localStorage.getItem(JWT);

	       fetch(
	           "/resolutionsoftwareplatform/roombookingdashboard/drawer",
	           {
	               method: "POST",
	               headers: {
	                   "Authorization":
	                       "Bearer " + token,
	                   "Content-Type":
	                       "application/json"
	               },
	               body: JSON.stringify(filter)
	           }
	       )
	       .then(function (response) {
	           return response.json();
	       })
	       .then(function (data) {

	           console.log(data);

	           props.setDrawerData(data);

	           props.setDetailsOpen(true);

	       })
	       .catch(function (error) {

	           console.error(
	               "Error loading booking drawer:",
	               error
	           );

	       });

	   }

    // --------------------------------------------------------
    // STYLES
    // --------------------------------------------------------

    const containerStyle = {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        padding: "16px",
        color: "#fff",
        height: "100%",
		zIndex:101
    };

    const ringGrid = {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "12px"
    };

    const ringCard = {
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: "4px",
        padding: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "135px"
    };

    const summaryCard = {
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: "4px",
        padding: "14px"
    };

    const summaryGrid = {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "10px"
    };

    const summaryItem = {
        borderLeft: "2px solid rgba(255,255,255,0.15)",
        paddingLeft: "10px",
        paddingTop: "2px",
        paddingBottom: "2px"
    };

    const summaryValue = {
        fontSize: "18px",
        fontWeight: "600",
        color: "#fff",
        lineHeight: "20px"
    };

    const summaryLabel = {
        fontSize: "10px",
        color: "#999",
        marginTop: "2px",
        textTransform: "uppercase",
        letterSpacing: "1px"
    };

    const sectionTitle = {
        fontSize: "11px",
        fontWeight: "600",
        color: "#fff",
        marginBottom: "12px",
        textTransform: "uppercase",
        letterSpacing: "1px"
    };

    const buttonContainer = {
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginTop: "auto"
    };

    const primaryButton = {
        background: "#5a9bd6",
        border: "none",
        borderRadius: "8px",
        padding: "12px",
        color: "#fff",
        fontSize: "13px",
        fontWeight: "600",
        cursor: "pointer"
    };

    const secondaryButton = {
        background: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: "8px",
        padding: "12px",
        color: "#fff",
        fontSize: "13px",
        fontWeight: "600",
        cursor: "pointer"
    };

    // --------------------------------------------------------
    // COMPONENTS
    // --------------------------------------------------------

    function SummaryItem(props) {

        return (

            <div style={summaryItem}>

                <div style={summaryValue}>
                    {props.value}
                </div>

                <div style={summaryLabel}>
                    {props.label}
                </div>

            </div>

        );
    }

	// --------------------------------------------------------
	// RENDER
	// --------------------------------------------------------
	return (

	    <div style={containerStyle}>

	        {/* ------------------------------------------------ */}
	        {/* SUMMARY METRICS */}
	        {/* ------------------------------------------------ */}
	        <div>

	            <div style={sectionTitle}>
	                Summary Metrics
	            </div>

	            <div style={ringGrid}>

	                <div style={ringCard}>
	                    <AmChartRingIndicator
	                        id="drawer_ring_booked"
	                        percentage={
	                            dashboard &&
	                            dashboard.rings
	                                ? dashboard.rings.avgBookedPercent
	                                : 0
	                        }
	                        label="Booked %"
	                        width={95}
	                        height={95}
	                    />
	                </div>

	                <div style={ringCard}>
	                    <AmChartRingIndicator
	                        id="drawer_ring_utilised"
	                        percentage={
	                            dashboard &&
	                            dashboard.rings
	                                ? dashboard.rings.avgUtilisedPercent
	                                : 0
	                        }
	                        label="Utilised %"
	                        width={95}
	                        height={95}
	                    />
	                </div>

	                <div style={ringCard}>
	                    <AmChartRingIndicator
	                        id="drawer_ring_noshow"
	                        percentage={
	                            dashboard &&
	                            dashboard.rings
	                                ? dashboard.rings.noShowPercent
	                                : 0
	                        }
	                        label="No Show %"
	                        width={95}
	                        height={95}
	                    />
	                </div>

	                <div style={ringCard}>
	                    <AmChartRingIndicator
	                        id="drawer_ring_ghost"
	                        percentage={
	                            dashboard &&
	                            dashboard.rings
	                                ? dashboard.rings.ghostPercent
	                                : 0
	                        }
	                        label="Ghost %"
	                        width={95}
	                        height={95}
	                    />
	                </div>

	            </div>

	        </div>

	        {/* ------------------------------------------------ */}
	        {/* OBSERVATION SUMMARY */}
	        {/* ------------------------------------------------ */}
	        <div style={summaryCard}>

	            <div style={sectionTitle}>
	                Observation Summary
	            </div>

	            <div style={summaryGrid}>

	                <SummaryItem
	                    label="Bookings"
	                    value={
	                        summary
	                            ? summary.totalBookings
	                            : 0
	                    }
	                />

	                <SummaryItem
	                    label="No Shows"
	                    value={
	                        summary
	                            ? summary.totalNoShows
	                            : 0
	                    }
	                />

	                <SummaryItem
	                    label="Observed"
	                    value={
	                        summary
	                            ? summary.totalObserved
	                            : 0
	                    }
	                />

	                <SummaryItem
	                    label="Ghosts"
	                    value={
	                        summary
	                            ? summary.totalGhosts
	                            : 0
	                    }
	                />

	            </div>

	        </div>

	        {/* ------------------------------------------------ */}
	        {/* ACTIONS */}
	        {/* ------------------------------------------------ */}
	        <div style={buttonContainer}>

	            <button
	                style={primaryButton}
	                onClick={function () {
	                    console.log("Apply filter");
	                }}
	            >
	                Apply Filter
	            </button>

	            <button
	                style={secondaryButton}
	                onClick={function () {
	                    openDetailsDrawer();
	                }}
	            >
	                View All Bookings
	            </button>

	        </div>

	    </div>

	);
}